  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[POPOVER]
  import Popover                                             from '@material-ui/core/Popover';
  import IconButton                                          from '@material-ui/core/IconButton';
  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import Typography                                          from '@material-ui/core/Typography';
  import InfoIcon                                            from '@material-ui/icons/Info';
  //[PASSWORDTYPE]
//import InputAdornment                                      from '@material-ui/core/InputAdornment';
//import IconButton                                          from '@material-ui/core/IconButton';
  import Visibility                                          from '@material-ui/icons/Visibility';
  import VisibilityOff                                       from '@material-ui/icons/VisibilityOff';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_ForgotPassService }                            from "../../_services";
  //------
  // Style
  //------
  import ForgotPass3Style                                    from "./ForgotPass3Style.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "ForgotPass3 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var ForgotPass3_continue_locked = true;

class ForgotPass3 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                 : "",
      dialog_isOpen                              : false,

      viewPleaseWait_hidden                      : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      textField1                                           : "",
      textField1_hasError                                  : false,
      textField2                                           : "",
      textField2_hasError                                  : false,

      passwordType1                                        : "password",
      passwordType2                                        : "password",

      //[POPOVER]
      password1_popover_isOpen                             : false,
      password2_popover_isOpen                             : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);

    this.get_PasswordType1                                           = this.get_PasswordType1.bind(this);
    this.handlePopoverOpen_passwordType1                             = this.handlePopoverOpen_passwordType1.bind(this);
    this.get_PasswordType2                                           = this.get_PasswordType2.bind(this);
    this.handlePopoverOpen_passwordType2                             = this.handlePopoverOpen_passwordType2.bind(this);

    this.handleSubmit                                                 = this.handleSubmit.bind(this);
    this.handleSubmit_isDisabled                                      = this.handleSubmit_isDisabled.bind(this);

    this.handleSubmit_with_recaptcha                                  = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                 = React.createRef();

    //[POPOVER]
    this.handlePopoverOpen_password1                                 = this.handlePopoverOpen_password1.bind(this);
    this.handlePopoverClose_password1                                = this.handlePopoverClose_password1.bind(this);
    this.handlePopoverOpen_password2                                 = this.handlePopoverOpen_password2.bind(this);
    this.handlePopoverClose_password2                                = this.handlePopoverClose_password2.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);
    if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    if(api.print_logs){console.log(methName+localStorage.getItem("curr_view")+",history.length="+history.length);}

    //[Lockers]
    this.stopLockers();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack Header]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ForgotPass3_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ForgotPass3_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.ForgotPass3_info}>{this.NSInforString("ForgotPass3_info")}</div>
              </GridItem>

              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField1_hasError}
                  className={classes.textField1}
                  id="textField1"
                  label={this.NSInforString("ForgotPass3_plh1")}
                  defaultValue=""
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "textField1"),
                    type: this.get_PasswordType1(),
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton onClick={this.handlePopoverOpen_password1} onMouseDown={this.handlePopoverOpen_password1} style={{padding:0}}><InfoIcon/></IconButton>
                        <IconButton onClick={this.handlePopoverOpen_passwordType1}  style={{padding:0}}> {this.get_PasswordType1()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                      </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="password1_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password1_popover_isOpen}
                  anchorEl={document.getElementById("textField1")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password1}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover>
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.textField2_hasError}
                  className={classes.textField2}
                  id="textField2"
                  label={this.NSInforString("ForgotPass3_plh2")}
                  defaultValue=""
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "textField2"),
                    type: this.get_PasswordType2(),
                    endAdornment:
                      <InputAdornment position="end">
                        <IconButton onClick={this.handlePopoverOpen_password2} onMouseDown={this.handlePopoverOpen_password2} style={{padding:0}}><InfoIcon/></IconButton>
                        <IconButton onClick={this.handlePopoverOpen_passwordType2}  style={{padding:0}}> {this.get_PasswordType2()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                      </InputAdornment>
                  }}
                />
                {/* ------------------------- */}
                {/* ----------[POPOVER]------ */}
                {/* ------------------------- */}
                <Popover
                  id="password2_popover"
                  className={classes.popover}
                  classes={{ paper:classes.paper }}
                  open={this.state.password2_popover_isOpen}
                  anchorEl={document.getElementById("textField2")}
                  anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
                  transformOrigin={{ vertical:'top', horizontal:'left' }}
                  onClose={this.handlePopoverClose_password2}
                  disableRestoreFocus
                >
                  <Typography style={{width:280, padding:5}}>{this.NSInforString("popover_generic_password")}</Typography>
                </Popover>
              </GridItem>

              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <GridItem xs={10} sm={10} md={10}>
                <div className={classes.textCenter}>
                  {/* <ReCAPTCHA
                    ref={ ref => this.recaptchaRef = ref }
                    locale={localStorage.getItem("lang")}
                    sitekey={api.captchKey}
                    onResolved={ this.handleSubmit } /> */}
                  <CustomButton
                    disabled={this.handleSubmit_isDisabled()}
                    className={classes.yellowButton}
                    color="rose"
                    onClick={this.handleSubmit}
                    type="submit">
                    {this.NSInforString("ForgotPass3_btn_save")}
                  </CustomButton>
                </div>
              </GridItem>
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("ForgotPass3_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              ) : ( "" ) }

            </GridContainer>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    let textField1text = this.state.textField1.trim();
    let textField2text = this.state.textField2.trim();

    let textField1text_hasGreekChar = false;
    for(let i=0; textField1text.length>0 && i<textField1text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField1text[i])===true){ textField1text_hasGreekChar=true; break; } }
    if(textField1text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    let textField2text_hasGreekChar = false;
    for(let i=0; textField2text.length>0 && i<textField2text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField2text[i])===true){ textField2text_hasGreekChar=true; break; } }
    if(textField2text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.state.textField1!==this.state.textField2){
        this.dialog_handleOpen(this.NSInforString("passwords.do.not.match"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.handleSubmit_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit(event) {
    let methName = filename+"handleSubmit ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.textField1.trim() === "") { this.setState({"textField1_hasError" : true }); emptyFields = true; }
      if(this.state.textField2.trim() === "") { this.setState({"textField2_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers();if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    let textField1text = this.state.textField1.trim();
    let textField2text = this.state.textField2.trim();

    let textField1text_hasGreekChar = false;
    for(let i=0; textField1text.length>0 && i<textField1text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField1text[i])===true){ textField1text_hasGreekChar=true; break; } }
    if(textField1text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let textField2text_hasGreekChar = false;
    for(let i=0; textField2text.length>0 && i<textField2text.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(textField2text[i])===true){ textField2text_hasGreekChar=true; break; } }
    if(textField2text_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(this.state.textField1!==this.state.textField2){
        this.dialog_handleOpen(this.NSInforString("passwords.do.not.match"));
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers(); return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //++++++++
    //Continue
    //++++++++
    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //------------------
      //wu_omtreqchangepwd
      //------------------
      wu_ForgotPassService
      .wu_omtchangepwd({newPassword:this.state.textField1})
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="ForgotPass3"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();this.stopSpinners();
        if(res.returnCode===0){
          wu_Utilities.LogoutUserFromApp(filename);
          history.push(wu_Utilities.getNavigationURLs("LoginPage")); //XXX SOS ???
        }
      })
      .catch(err => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers(); this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500)
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="textField1"){
      this.setState({
        "textField1"          : eventTMP.trim(),
        "textField1_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"textField1_hasError":true}); return; } }
    }
    else if(stateVar==="textField2"){
      this.setState({
        "textField2"          : eventTMP.trim(),
        "textField2_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"textField2_hasError":true}); return; } }
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[POPOVER]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_password1(){
    this.setState({ "password1_popover_isOpen" : true, });
  }
  handlePopoverClose_password1(){
    this.setState({ "password1_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  handlePopoverOpen_password2(){
    this.setState({ "password2_popover_isOpen" : true, });
  }
  handlePopoverClose_password2(){
    this.setState({ "password2_popover_isOpen" : false, });
  }
  //----------------------------------------------------------------------------------------------------
  get_PasswordType1(){
    return this.state.passwordType1;
  }
  handlePopoverOpen_passwordType1(){
    if(this.state.passwordType1==="password"){this.setState({ "passwordType1" : "text", });}
    if(this.state.passwordType1==="text")    {this.setState({ "passwordType1" : "password", });}
  }
  get_PasswordType2(){
    return this.state.passwordType2;
  }
  handlePopoverOpen_passwordType2(){
    if(this.state.passwordType2==="password"){this.setState({ "passwordType2" : "text", });}
    if(this.state.passwordType2==="text")    {this.setState({ "passwordType2" : "password", });}
  }
  get_PasswordType3(){
    return this.state.passwordType3;
  }
  handlePopoverOpen_passwordType3(){
    if(this.state.passwordType3==="password"){this.setState({ "passwordType3" : "text", });}
    if(this.state.passwordType3==="text")    {this.setState({ "passwordType3" : "password", });}
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( ForgotPass3_continue_locked===true ){ return true;  }
    else                                    { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    ForgotPass3_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    ForgotPass3_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"FP3"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
}
ForgotPass3.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(ForgotPass3Style)(ForgotPass3)
);
